import { render } from "./ClientContactCard.vue?vue&type=template&id=cc7a349c&scoped=true"
import script from "./ClientContactCard.vue?vue&type=script&lang=js"
export * from "./ClientContactCard.vue?vue&type=script&lang=js"

import "./ClientContactCard.vue?vue&type=style&index=0&id=cc7a349c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc7a349c"]])

export default __exports__